// extracted by mini-css-extract-plugin
export default {"userBlock":"User_userBlock__jbIcB","photo":"User_photo__ZzG3M","name":"User_name__JOVQV","button":"User_button__SFqOk"};